"use client";

import Image from "next/image";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";

import HeroPricingCard from "./HeroPricingCard";
import HeroPaymentMethods from "./HeroPaymentMethods";
import HeroStats from "./HeroStats";
import background from "@/public/futures-v2/hero-bg.png";
import { PageFuturesOldDesignSchema } from "@/sanity/pages/PageFuturesOldDesignTemplate";
import { cn } from "@/lib/utils";

export default function HeroSection({
  data,
  className,
  showTopBanner,
  futures = false,
}: {
  data: PageFuturesOldDesignSchema;
  className?: string;
  showTopBanner?: boolean;
  futures?: boolean;
}) {
  return (
    <section
      className={cn(
        "relative z-0 overflow-x-clip px-[2rem] lg:px-[5rem] pt-[8rem] lg:pt-[5rem]",
        showTopBanner && "pt-[8rem] lg:pt-[14rem]",
        className,
      )}>
      <div
        style={{
          background: "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%)",
        }}
        className="absolute bottom-[-5%] h-[40rem] w-full left-0 z-[1]"></div>
      <div className="absolute inset-0 z-0 w-full h-full overflow-clip">
        <Image
          src={background}
          alt="Hero background"
          className="object-cover object-top w-full h-full"
          priority
        />
      </div>
      <div className="relative z-10">
        <div className="container flex relative z-10 flex-col items-center gap-[8.75rem]">
          <div className="w-[min(97.5rem,100%)]  flex flex-col items-center gap-[5.88rem] lg:gap-[4.62rem]">
            <div className="flex flex-col items-center text-center gap-[2rem]">
              {data?.heroChip && (
                <p className="mb-0 font-medium font-instrument text-black/70 text-[1.75rem] lg:text-[2rem]">
                  {data.heroChip}
                </p>
              )}

              {data?.heroText && (
                <div
                  className={cn(
                    "richtext [&_br]:hidden lg:[&_br]:block flex flex-col gap-[2rem] text-center items-center [&_span]:!font-gestura [&_span]:!text-[#6da991] [&_span]:font-bold prose-p:mb-0 lg:prose-p:max-w-[80%] prose-headings:mb-0 prose-headings:font-instrument-sans",
                    data?.settings?.slug?.current?.endsWith("/br") ? "[&_br]:block" : "[&_br]:hidden",
                  )}>
                  <PortableText
                    value={data.heroText}
                    components={richTextComponent}
                  />
                </div>
              )}
            </div>

            <div className="flex flex-col items-center gap-[5.875rem]">
              <HeroPricingCard data={data} />
              <HeroPaymentMethods
                label={data?.paymentLabel}
                methods={data?.paymentMethods}
              />
            </div>
          </div>

          <HeroStats stats={data?.stats} />
        </div>
      </div>
    </section>
  );
}
